<mat-drawer-container class="dashboard-container">
    <mat-drawer #drawer mode="side" opened class="sidebar">
        <app-sidebar (closebtnClick) = "drawer.toggle()" ></app-sidebar>
    </mat-drawer>
    <mat-drawer-content>
        <div class="navigation-wrap bg-light start-header start-style">
            <div class="row">
              <div class="col-12">
                <nav class="navbar navbar-expand-md navbar-light">
          
                  <button i18n class="navbar-toggler" type="button"  (click)="drawer.toggle()">
                    <span class="navbar-toggler-icon"></span>
                  </button>

                  <div class="nav-box">
                    <div class="item-list">
                      <p i18n  style="color:#000; padding-top: 0px;">{{username}}</p>
                      <div class="profile" data-toggle="dropdown">
                        <img [src]="avatar" alt="profile" class="nav-avatar dropdown-toggle">
                        <a i18n class="nav-link dropdown-toggle" href="#" role="button" aria-haspopup="true"
                          aria-expanded="false">{{username}}</a>
                        <mat-icon class="arrow-icon">keyboard_arrow_down</mat-icon>
                      </div>

                      <div class="dropdown-menu">
                        <a i18n class="dropdown-item" routerLink="/dashboard/profile">Profile</a>
                        <a i18n class="dropdown-item" (click)="logout()">Sign out</a>
                      </div>
                                    
                      <button i18n (click)="selectLanguage()" class="select-language-button" mat-raised-button>
                        Select Language
                      </button>
                    </div>
                    </div>
                    
                </nav>
              </div>
            </div>
          </div>
          
          <router-outlet></router-outlet>
    </mat-drawer-content>
</mat-drawer-container>